import React from 'react';
import './infoCardsSection.scss';
import MainInfoGif from './components/MainInfoGif.gif';
import SlideItemsComponent from "./components/SlideItemsComponent";

const InfoCardsSection = () => {
	return (
		<div className="infoCardsSection">
			<div className="infoCardsSection__content">
				<div className="infoCardsSection__content_slides">
					<SlideItemsComponent />
				</div>
				<div className="infoCardsSection__content_gif">
					<img src={MainInfoGif} alt="MainInfoGif" />
				</div>
			</div>
		</div>
	);
};

export default InfoCardsSection;